import { t } from 'i18next';
import * as yup from 'yup';

import { emailRegex } from '~constants/regexConst';

export const emailSchema = yup
  .string()
  .email(`${t('form_validation_errors.required', { field: t('form_fields.email') })}`)
  .matches(emailRegex, `${t('form_validation_errors.invalid_email')}`)
  .required(() => t('form_validation_errors.required', { formField: 'email' }));
